module.exports = __webpack_public_path__ + "assets/img/starter_home.b44d327e.jpg";